import React from 'react'
import { constants } from 'common/helpers'

import composeDialogModal from 'components/modal/DialogModal/composeDialogModal'

import messages from './messages'


const AlreadyDowngradeModal = composeDialogModal({
  name: constants.modals.AlreadyDowngrade,
  title: messages.title,
  buttonTitle: messages.buttonTitle,
  contentMessage: ({ data: { price } }) => ({
    ...messages.text,
    values: { price },
  }),
})

export default AlreadyDowngradeModal
